export function spaceToDash(input: string) {
    input = input || "";
    input = input.trim().replaceAll(/\s{2,}/g, " ");
    return input.split(" ").join("-");
}
